import { connect } from "react-redux";

import { userSelectsReportBook } from "../actions/report_book";
import ReportBook from "../components/report_book";

const mapStateToProps = (state) => {
  return {
    reportBook: state.filters.reportBook
  };
};

const mapDispatchToProps = dispatch => ({
  onChange: (e) => { dispatch(userSelectsReportBook(e)); }
});

export default connect(mapStateToProps, mapDispatchToProps)(ReportBook);
